import Image from "next/image";
import { Line } from "react-chartjs-2";
import Link from "next/link";
import {getProjects} from "../../../utils/api";
import {useEffect, useState} from "react";

const DataTable = () => {
  const [itemdata, setItemdata] = useState([]);
  const { data, error } = getProjects();

  useEffect(() => {
    if (data) {
      setItemdata(data);
    }
  }, [data]);

  return (
    <>
      {itemdata && itemdata.map((item) => (
          <div
              key={item.projectId}
              className="flex flex-wrap justify-between border-t border-jacarta-100 py-2 px-4 transition-shadow hover:shadow-lg dark:border-jacarta-600 dark:bg-jacarta-900"
              role="row"
          >
            <div className="flex w-1/2 sm:w-[30%] lg:w-[24%]" role="cell">
              <figure className="relative mr-3 w-8 shrink-0 self-start lg:w-10">
                <Image
                    width={40}
                    height={40}
                    src={`/images/projects/${item.projectId}.webp`}
                    alt="items"
                    className="rounded-2lg"
                    loading="lazy"
                />
              </figure>
              <div>
              <span className="block text-sm text-jacarta-700 dark:text-white">
                {item.projectName}
              </span>
                <span className="text-xs text-jacarta-500 dark:text-jacarta-400">
                {item.projectNo}
              </span>
              </div>
            </div>
            <div
                className="hidden w-[18%] text-right sm:block md:w-[12%] lg:w-[10%]"
                role="cell"
            >
              <span className="block">{item.calcCADRToMint}</span>
              <span
                  className={`text-xs ${
                      item.percentage?.includes("-") ? "text-red" : "text-green"
                  }`}
              >
              {item.percentage}
            </span>
            </div>
            <div
                className="flex w-1/4 flex-col items-end justify-center text-right text-xs sm:w-[12%] lg:w-[11%]"
                role="cell"
            >
              <div className="flex items-center justify-end">
                <span>{item.mint}</span>
                <span title="ETH">-</span>
              </div>
              <div className="flex items-center justify-end">
                <span>{item.floor}</span>
                <span title="ETH">-</span>
              </div>
            </div>
            <div
                className="flex w-1/4 flex-col items-end justify-center text-right text-xs sm:w-[12%] lg:w-[11%]"
                role="cell"
            >
              <div className="flex items-center justify-end">
                <span>{item.mint}</span>
                <span title="ETH">-</span>
              </div>
              <div className="flex items-center justify-end">
                <span>{item.floor}</span>
                <span title="ETH">-</span>
              </div>
            </div>
            <div
                className="hidden w-[12%] flex-col items-end justify-center text-xs lg:flex"
                role="cell"
            >
              <div className="mb-1.5">
              <span className="text-sm text-jacarta-700 dark:text-white">
                {item.percentage}
              </span>
                <span>&nbsp;(0)</span>
              </div>
              <div className="w-24 overflow-hidden rounded-lg bg-jacarta-100 dark:bg-jacarta-600">
                <div
                    className="h-1.5 rounded-lg bg-accent"
                    style={{width: item.percentage}}
                />
              </div>
            </div>
            <div
                className="flex w-1/4 flex-col items-end justify-center text-right text-xs sm:w-[12%] lg:w-[12%]"
                role="cell"
            >
              <div>
                <span className="text-sm">{item.calcCADRMinted}</span>
              </div>
              <span>of {item.calcCADRMinted + item.calcCADRToMint}</span>
            </div>

            <div
                className="mt-1 w-[9%] items-center justify-end sm:mt-0 sm:flex"
                role="columnheader"
            >
              <Link
                  href={"/item/" + item.projectId}
                  className="inline-block rounded-full bg-accent py-1 px-4 text-center text-xs font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark"
              >
                View
              </Link>
            </div>
          </div>
      ))}
    </>
  );
};

export default DataTable;
